import React from 'react';
import { Trans } from 'react-i18next';

export type TextContentType =
  | string
  | React.ReactElement
  | { i18nKey: string; values?: Record<string, any> };

export default function renderTextContent(
  value: TextContentType,
): React.ReactNode {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object' && 'i18nKey' in value) {
    return <Trans {...value} />;
  }

  return value;
}
